import React, { Component } from 'react';
import IndexMain from '../../components/IndexMain/IndexMain';
import paths from '../../constants/paths';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { nbsApiAppleAuth } from '../../store/actions/appleAuth';
import { storeAppleData } from '../../store/actions/appleData';
import { setSessionToken } from '../../store/actions/session';
import strings from '../../assets/localization';
import { resetAccountStatus } from '../../store/actions/resetAccountStatus';
import { getRomanceGuardParam, isEmpty } from '../../assets/helpers/utils';
import URLSearchParams from 'url-search-params';
import { setUserCreateAccountData } from '../../store/actions/createAccountData';
import { uuid } from '../../assets/helpers/utils';

class IndexPage extends Component {
  state = {
    showAlert: false,
    errorMessage: null,
    accountStatus: false,
    showLogout: false,
    showReactivateModal: false,
    isReactivateApple: false,
    mailIsConfirmed: false,
    queryString: '',
    showSpinner: false,
    isOneClick: false,
  };

  loginTokenAuthData = null;

  componentDidMount() {
    // console.log('IndexPage mounted', this.props);

    const query = new URLSearchParams(this.props.location.search);
    const restorePasswordToken = query.get('restore_password_token');

    if (restorePasswordToken) {
      query.delete('restore_password_token');
      this.props.history.replace({
        pathname: paths.NEW_PASSWORD + '/' + restorePasswordToken + '/',
        search: query.toString(),
      });
      return;
    }

    if (query.get('contact_us')) {
      query.delete('contact_us');
      this.props.history.replace({
        pathname: paths.CONTACT_US,
        search: query.toString(),
      });
      return;
    }

    if (query.toString()) {
      this.setState({ queryString: query.toString() });
    }

    if (this.props.location.search.includes('code')) {
      const ref = document.referrer;
      if (!ref.match(/appleid|apple\.com/)) {
        this.props.history.push(paths.INDEX);
      } else {
        const code = query.get('code').trim();
        this.props.storeAppleData(code);
        this.loginWithApple(code);
      }
    }

    if (query.get('oneclick')) {
      this.setState({ isOneClick: true });
    }
  }

  componentDidUpdate(prevProps) {
    const { appleAuth, checkAccountStatus } = this.props;

    if (
      appleAuth.status === 'success' &&
      prevProps.appleAuth.status !== 'success'
    ) {
      this.props.setSessionToken(appleAuth.response.token);
    } else if (
      appleAuth.status === 'fail' &&
      prevProps.appleAuth.status !== 'fail'
    ) {
      if (appleAuth.error.error_code === 3) {
        this.setState({ showReactivateModal: true, isReactivateApple: true });
      } else {
        this.toggleAlertError(appleAuth.error.error);
      }
    }

    if (checkAccountStatus.logOut && !this.state.showLogout) {
      this.setState({ showLogout: true });
      this.props.resetAccountStatus();
    }

    if (checkAccountStatus.deactivate && !this.state.showAlert) {
      this.setState({ accountStatus: true });
      this.toggleAlertError(strings.accountSuccDeact);
    }

    if (checkAccountStatus.delete && !this.state.showAlert) {
      this.setState({ accountStatus: true });
      this.props.history.push(paths.INDEX);
      window.scrollTo(0, 0);
      this.toggleAlertError(strings.accountSuccDelete);
    }
  }

  gotoLogin = () => {
    this.props.history.push({
      pathname: paths.LOGIN,
      search: this.state.queryString,
    });
  };

  goBack = () => {
    this.setState((prevState) => ({
      showReactivateModal: !prevState.showReactivateModal,
    }));
  };

  goToCreateAccount = (step = 1) => {
    if (typeof step === 'number') {
      this.props.setUserCreateAccountData({ step });
    }
    this.props.history.push({
      pathname: paths.SIGNUP,
      search: this.state.queryString,
    });
  };

  toggleAlertError = (errorMessage) => {
    this.setState((prevState) => ({
      showAlert: !prevState.showAlert,
      errorMessage,
    }));
    if (this.state.accountStatus) {
      this.props.resetAccountStatus();
    }
  };

  loginWithApple = (data, activate = null) => {
    const obj = {
      login_type: 'apple',
      signup_type: 'apple',
      code: !isEmpty(this.props.appleData) ? this.props.appleData : data,
      device_type: 3,
      platform: 'web',
      __RG: getRomanceGuardParam(),
      activate,
    };

    if (this.props.metaPixels.fbc) {
      obj.meta_fbc = this.props.metaPixels.fbc;
    }

    if (this.props.metaPixels.fbp) {
      obj.meta_fbp = this.props.metaPixels.fbp;
    }

    obj.meta_event_id = uuid();

    this.props.nbsApiAppleAuth(obj);
  };

  render() {
    return (
      <IndexMain
        setUserCreateAccountData={this.props.setUserCreateAccountData}
        getConfig={this.props.getConfig}
        showSpinner={this.state.showSpinner}
        history={this.props.history}
        showReactivateModal={this.state.showReactivateModal}
        isReactivateApple={this.state.isReactivateApple}
        loginWithApple={this.loginWithApple}
        appleData={this.props.appleData}
        gotoLogin={this.gotoLogin}
        goBack={this.goBack}
        errorAlertMessage={this.state.errorMessage}
        showErrorAlert={this.state.showAlert}
        dismissAlert={this.toggleAlertError}
        accountStatus={this.state.accountStatus}
        goToCreateAccount={this.goToCreateAccount}
        isLandscape={this.props.isLandscape}
        isOneClick={this.state.isOneClick}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  appleData: state.appleData.appleLoginData,
  appleAuth: state.appleAuth,
  checkAccountStatus: state.checkAccountStatus,
  getConfig: state.getConfig,
  metaPixels: state.metaPixels,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      nbsApiAppleAuth,
      storeAppleData,
      setSessionToken,
      resetAccountStatus,
      setUserCreateAccountData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(IndexPage);
